export enum RemoveCustomerStatus {
  ALLOWED = 'Allowed',
  LAST_CUSTOMER = 'LastCustomer',
  LAST_ADULT_WITH_CHILD_TRAUMA = 'LastAdultWithChildTrauma',
  CUSTOMER_HAS_DEPENDENCIES = 'CustomerHasDependencies',
  CUSTOMER_NOT_SELECTED = 'CustomerNotSelected',
}
